/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdraftemptyerror3Inputs */

const en_eventdraftemptyerror3 = /** @type {(inputs: Eventdraftemptyerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a few words, paste a link or add a picture.`)
};

const de_eventdraftemptyerror3 = /** @type {(inputs: Eventdraftemptyerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreib ein paar Worte, füg einen Link ein oder ein Bild hinzu.`)
};

/**
* | output |
* | --- |
* | "Write a few words, paste a link or add a picture." |
*
* @param {Eventdraftemptyerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdraftemptyerror3 = /** @type {((inputs?: Eventdraftemptyerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdraftemptyerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdraftemptyerror3(inputs)
	return de_eventdraftemptyerror3(inputs)
});
export { eventdraftemptyerror3 as "eventDraftEmptyError" }